import React from 'react'
import {connect} from 'react-redux'
import {Button, Divider, Image, Layout, Menu} from 'antd'
import {withRouter} from 'react-router'

import {VerticalLeftOutlined, VerticalRightOutlined} from '@ant-design/icons'

import {breakpointFold, breakpointUnfold, menuFoldOut, menuUnfoldOut} from '../action/style'
import '../asset/less/component.css'
import {siders} from '../router'
import logoRoundSmall from '../asset/image/smART_Manager.png'
import {URL_CONTACTS} from "../const";
import DashboardTourModal from "./dashboard/DashboardTourModal";
import {checkFirstTimeDashboardUser} from "../app/util";

const {Sider} = Layout
const {SubMenu} = Menu

@connect(
    (state) => ({
        siderCollapsed: state.style.siderCollapsed,
        siderWidth: state.style.siderWidth,
        id: state.user.info.id, // real user id, admin_id or artist_id
        role: state.user.info.role
    }),
    {
        menuFoldOut,
        menuUnfoldOut,
        breakpointFold,
        breakpointUnfold
    }
)
class SAMSider extends React.Component {
    constructor(props) {
        super(props)
        this.rootSubmenuKeys = siders.filter((sider) => sider.role.includes(this.props.role)).map((sider) => sider.key)
        if (!this.props.location.pathname || this.props.location.pathname === '' || this.props.location.pathname === '/sam/'
            || this.props.location.pathname === '/sam/dashboard/') {
            this.defaultSelectedKeys = ['/sam/dashboard/']
            let firstTime = checkFirstTimeDashboardUser(props)
            const firstTimeKeys = ['pieces', 'showcase', 'income', 'documents', URL_CONTACTS]
            let openKeys = ['/sam/dashboard/']
            if (firstTime) {
                openKeys = openKeys.concat(firstTimeKeys)
            }
            this.state = {
                openKeys: openKeys,
                mouseInSider: false,
            }
            return
        }
        if (this.props.location?.pathname === '/sam/pieces/') {
            this.defaultSelectedKeys = ['/sam/pieces/']
            this.state = {
                openKeys: ['pieces'],
                mouseInSider: false
            }
            return
        }
        const path = this.props.location.pathname.split('/')
        this.defaultSelectedKeys = this.props.location.pathname
        try {
            this.state = {
                openKeys: ['/' + path[0] + '/' + path[1] + '/'],
                mouseInSider: false
            }
        } catch (e) {
            this.state = {
                openKeys: [''],
                mouseInSider: false
            }
        }
    }

    onMenuClick = ({item, key, keyPath, domEvent}) => {
        this.props.history.push({
            pathname: key
        })
        if (this.state.collapsed) {
            this.props.menuFoldOut()
        }
    }

    onOpenChange = (keys) => {
        const latestOpenKey = keys.find((key) => this.state.openKeys.indexOf(key) === -1)
        if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            this.setState({openKeys: keys})
        } else {
            this.setState({openKeys: [latestOpenKey ? latestOpenKey : null]})
        }
    }

    render() {
        const openKeys = !this.props.siderCollapsed ? [] : this.state.openKeys
        const color = '#0531ad'
        const dashboard = [
            <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
                key={0}
            >
                <path
                    d="M3 4C3 3.44772 3.44772 3 4 3H16C16.5523 3 17 3.44772 17 4V6C17 6.55228 16.5523 7 16 7H4C3.44772 7 3 6.55228 3 6V4Z"
                    fill={color}
                ></path>
                <path
                    d="M3 10C3 9.44771 3.44772 9 4 9H10C10.5523 9 11 9.44771 11 10V16C11 16.5523 10.5523 17 10 17H4C3.44772 17 3 16.5523 3 16V10Z"
                    fill={color}
                ></path>
                <path
                    d="M14 9C13.4477 9 13 9.44771 13 10V16C13 16.5523 13.4477 17 14 17H16C16.5523 17 17 16.5523 17 16V10C17 9.44771 16.5523 9 16 9H14Z"
                    fill={color}
                ></path>
            </svg>,
        ];

        const buttonLeft = (this.props.siderCollapsed ? (this.state.collapsed ? '86vw' : Math.max(32, this.props.siderWidth - 64)) : (this.props.siderWidth))

        return (
            <div
                onMouseEnter={() => {
                    this.setState({mouseInSider: true})
                }}
                onMouseLeave={() => {
                    this.setState({mouseInSider: false})
                }}
                className={`layout-dashboard ${
                    "layout-dashboard-rtl"
                }`}
                style={{
                    zIndex: 1000
                }}
            >
                <Sider
                    width={this.state.collapsed ? '100vw' : this.props.siderWidth}
                    breakpoint='lg'
                    collapsedWidth='0'
                    trigger={null}
                    className={`sider-primary ant-layout-sider-primary ${
                        "active-route"
                    }`}
                    onBreakpoint={(collapsed) => {
                        this.setState({
                            collapsed: collapsed
                        })
                        if (collapsed) {
                            this.props.menuFoldOut()
                            this.props.breakpointFold()
                        } else {
                            this.props.menuUnfoldOut()
                            this.props.breakpointUnfold()
                        }
                    }}
                    collapsed={!this.props.siderCollapsed}
                    style={{
                        overflowY: 'scroll',
                        height: '100vh',
                        position: 'fixed',
                        paddingTop: 4,
                        backgroundColor: '#fff',
                        top: 0,
                        left: 0,
                        bottom: 0,
                        zIndex: !this.props.siderCollapsed ? 1000 : (this.state.collapsed ? 1000 : 1000)
                    }}
                >

                    <Button
                        icon={this.props.siderCollapsed ? <VerticalRightOutlined/> : <VerticalLeftOutlined/>}
                        style={{
                            position: 'fixed',
                            marginTop: '16px',
                            left: buttonLeft,
                            zIndex: 1015,
                        }}
                        size='middle'
                        className='sider-collapsed-button'
                        onClick={() => {
                            if (this.props.siderCollapsed) {
                                this.props.menuFoldOut()
                            } else {
                                this.props.menuUnfoldOut()
                            }
                        }}
                    />
                    <Menu
                        theme='light'
                        mode='inline'
                        openKeys={openKeys}
                        onOpenChange={this.onOpenChange}
                        defaultSelectedKeys={this.defaultSelectedKeys}
                        style={{
                            backgroundColor: 'white',
                            paddingLeft: 16,
                            paddingRight: 32
                        }}
                        onClick={this.onMenuClick}
                    >
                        <div
                            style={{
                                paddingLeft: 24,
                                paddingTop: 6,
                                display: 'flex',
                                flexDirection: 'rows',
                                alignItems: 'center',
                                gap: 8
                            }}
                        >
                            <Image
                                src={logoRoundSmall}
                                preview={false}
                                width='124px'
                                height='54px'
                                style={{marginLeft: 12}}
                                onClick={() => {
                                    window.open('https://revart.co/sam/', '_blank')
                                }}
                            />
                        </div>
                        <Divider/>
                        {siders.map((route) => {
                            if (!route.role.includes(this.props.role)) {
                                return
                            }
                            let divider = null
                            if (Object.prototype.hasOwnProperty.call(route, 'subMenu')) {
                                return (
                                    <>
                                        <SubMenu
                                            style={{
                                                marginLeft: 12,
                                                marginRight: 12,
                                                paddingTop: 6,
                                                paddingBottom: 6,
                                                fontSize: '0.9rem'
                                            }}
                                            id={route.data_tut}
                                            data_tut={route.data_tut}
                                            key={route.key}
                                            icon={route.icon}
                                            title={route.title}
                                            onTitleClick={
                                                route.link &&
                                                (() => {
                                                    this.props.history.push({
                                                        pathname: route.link
                                                    })
                                                })
                                            }
                                        >
                                            {route.subMenu.map((menu) => {
                                                if (!menu.role.includes(this.props.role)) {
                                                    return
                                                }
                                                return <Menu.Item data_tut={menu.data_tut} key={menu.key}>{menu.title}</Menu.Item>
                                            })}
                                        </SubMenu>
                                        {divider}
                                    </>
                                )
                            } else {
                                return (
                                    <>
                                        <Menu.Item style={{
                                            marginLeft: 12, marginRight: 8, paddingTop: 6,
                                            paddingBottom: 6
                                        }}
                                                   key={route.key} icon={route.icon} data-tut={route.data_tut}>
                                            <span style={{fontSize: '0.9rem'}}>{route.title}</span>
                                        </Menu.Item>
                                        {divider}
                                    </>
                                )
                            }
                        })}

                        <div style={{
                            width: '100%', paddingTop: "64px", paddingBottom: "33px", marginLeft: 'auto',
                            marginRight: 'auto', maxWidth: '384px', paddingLeft: 12
                        }}>
                            <div
                                className="footer-box"
                                style={{
                                    background: color,
                                    color: '#fff',
                                    boxShadow: "none",
                                    padding: 16,
                                    borderRadius: 8,
                                    marginBottom: 8,
                                    textAlign: 'left',
                                    fontSize: 14,
                                    lineHeight: 1.5715,
                                    wordWrap: 'break-word',
                                    letterSpacing: '-0.3px',
                                    fontWeight: 400
                                }}
                            >
                          <span className="icon" style={
                              {
                                  "display": "inline-flex",
                                  "width": "32px",
                                  "height": "32px",
                                  "boxShadow": "0 4px 6px rgb(0 0 0 / 12%)",
                                  "borderRadius": "6px",
                                  "justifyContent": "center",
                                  "alignItems": "center",
                                  "marginBottom": "15px",
                                  "backgroundColor": "#fff",
                                  color: color
                              }}>
                            {dashboard}
                          </span>
                                <h6 style={{
                                    color: 'white',
                                    fontSize: 16,
                                    fontWeight: 600,
                                    marginTop: 0,
                                    marginBottom: 0
                                }}>Need Help?</h6>
                                <p style={{
                                    color: 'f5f5f5',
                                    marginBottom: '1rem',
                                    marginTop: 8,
                                    fontWeight: 600,
                                    fontSize: 14
                                }}>Read our guide.</p>
                                <Button
                                    data-tut="reactour__faq"
                                    style={{
                                        background: '#fff !important',
                                        borderColor: '#f0f0f0',
                                        color: '#141414',
                                        width: '100%',
                                        margin: 0,
                                        boxShadow: '0 2px 4px rgb(0 0 0 / 7%)',
                                        borderRadius: 6,
                                        fontWeight: 600,
                                        fontSize: 12,
                                        height: 40,
                                        padding: '0 15px'
                                    }} onClick={()=>{
                                        window.open('https://revart.co/sam/faq/docs/doc-main', '__blank')
                                }}>
                                    Help Center
                                </Button>
                            </div>
                        </div>
                    </Menu>
                </Sider>
            </div>
        )
    }
}

export default withRouter(SAMSider)
